import { LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { arrayOf, bool, eventListener, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { TokenShape, TokenSize } from './token-list-constants.js';
const TokenListProperties = {
    className: {
        type: string,
    },
    collapsed: {
        defaultValue: true,
        type: bool,
    },
    data: {
        defaultValue: [],
        type: arrayOf(object).notEnumerable(),
    },
    justifyContent: {
        defaultValue: LayoutJustify.START,
        type: oneOf([LayoutJustify.START, LayoutJustify.END]).group('alignment'),
    },
    noWrap: {
        defaultValue: true,
        type: bool,
    },
    onBeforeDismiss: {
        type: eventListener,
    },
    onClick: {
        type: eventListener,
    },
    onContextMenuClick: {
        type: eventListener,
    },
    onDismiss: {
        type: eventListener,
    },
    onDoubleClick: {
        type: eventListener,
    },
    shape: {
        defaultValue: TokenShape.CIRCLE,
        type: oneOf(enumValues(TokenShape)),
    },
    size: {
        defaultValue: TokenSize.NORMAL,
        type: oneOf(enumValues(TokenSize)),
    },
    squeezed: {
        defaultValue: false,
        type: bool,
    },
};
export { TokenListProperties, };
//# sourceMappingURL=token-list-types.js.map